import { BaseRepository } from './BaseRepository'

export class LogoutRepository extends BaseRepository {
    logout = async () => {
        return await super.getHttpClientInstance().post(`/api/logout`)
    }
}
